import type { User } from "@mc/types"
import { apiRequest } from "./httpClient.js"

interface Credentials {
  username: string
  password: string
}

export function registerUser(credentials: Credentials): Promise<{ user: User }> {
  return apiRequest("/api/v1/auth/register", { method: "POST", body: credentials })
}

export function loginUser(credentials: Credentials): Promise<{ user: User }> {
  return apiRequest("/api/v1/auth/login", { method: "POST", body: credentials })
}

export function logoutUser(): Promise<void> {
  return apiRequest("/api/v1/auth/logout", { method: "POST" })
}

export function fetchCurrentUser(): Promise<{ user: User }> {
  return apiRequest("/api/v1/auth/me", { skipRefresh: false })
}

/** Backs the unified username-first auth screen: whether to show a password field or the create-account form. */
export function checkUserExists(username: string): Promise<{ exists: boolean }> {
  return apiRequest(`/api/v1/auth/user-exists?username=${encodeURIComponent(username)}`)
}
